// extracted by mini-css-extract-plugin
module.exports = {"container":"aaz_e","imageContainer":"aaz_be","eventImage":"aaz_l0","textContainer":"aaz_l1","title":"aaz_eg","subtext":"aaz_l2"};